import { Injectable } from "@angular/core";
import { Http, RequestOptions } from "@angular/http";
import { catchError, map } from "rxjs/operators";
import { environment } from "../../environments/environment";
import { AuthHeaderService } from "../views/authheader.service";
import { throwError as observableThrowError, Observable } from "rxjs";
@Injectable({
  providedIn: "root",
})
export class ReportService {
  reporturl: string;
  constructor(private http: Http, private _headerService: AuthHeaderService) {
    this.reporturl = environment.reporturl;
  }
  getArAgingData(isJobLoad?) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    if(isJobLoad){
      options.headers.append('is-only-jobload', "true");
    }
    return this.http.get(this.reporturl + "/araging", options).pipe(
      map((response) => (response.json().data ? [] : response.json())),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  getApAgingData() {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });

    return this.http.get(this.reporturl + "/apaging", options).pipe(
      map((response) => (response.json().data ? [] : response.json())),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  getUtilizationReport() {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(this.reporturl + "/utilization", options).pipe(
      map((response) => (response.json().data ? [] : response.json())),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  getLoadProfitabilityReport() {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(this.reporturl + "/loadprofitability", options).pipe(
      map((response) => (response.json().data ? [] : response.json())),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  getResourceProfitabilityReport() {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http
      .get(this.reporturl + "/resourceprofitability", options)
      .pipe(
        map((response) => (response.json().data ? [] : response.json())),
        catchError((error: Response) => {
          return observableThrowError(error);
        })
      );
  }
  getIncomeStatementReport(searchOptions) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    let url =
      this.reporturl +
      "/incomestatement" +
      "?" +
      "fromDate=" +
      searchOptions["fromDate"] +
      "&" +
      "toDate=" +
      searchOptions["toDate"];
    if (
      searchOptions["displayColum"] != "" &&
      searchOptions["displayColum"] != null
    ) {
      url = url + "&" + "displayColum=" + searchOptions["displayColum"];
    }
    return this.http.get(url, options).pipe(
      map((response) => (response.json().data ? [] : response.json())),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  getBalanceSheetReport(searchOptions) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    let url =
      this.reporturl +
      "/balancesheet" +
      "?" +
      "fromDate=" +
      searchOptions["fromDate"] +
      "&" +
      "toDate=" +
      searchOptions["toDate"];
    return this.http.get(url, options).pipe(
      map((response) => (response.json().data ? [] : response.json())),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
}
